// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconLock = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M50.5794 23.201C50.3356 22.1138 49.6513 21.4979 48.4432 21.2785C47.314 21.0734 45.8406 20.8389 44 20.6272V16C44 8.59552 39.4045 4 32 4C24.5955 4 20 8.59552 20 16V20.6368C18.085 20.8548 16.5916 21.0905 15.5568 21.2785C14.3487 21.4979 13.6644 22.1138 13.4206 23.201C12.8228 25.8666 12 30.6462 12 38C12 45.3538 12.8855 50.4131 13.4206 52.7989C13.6644 53.8862 14.3487 54.502 15.5568 54.7215C18.5185 55.2595 23.8292 56 32 56C40.1708 56 45.7924 55.203 48.4432 54.7215C49.6513 54.502 50.3356 53.8862 50.5794 52.7989C51.1145 50.4131 52 45.3538 52 38C52 30.6462 51.1772 25.8666 50.5794 23.201ZM26 16C26 11.9067 27.9062 10 32 10C36.0938 10 38 11.9067 38 16V20.1448C36.1998 20.0552 34.2078 20 32 20C29.8124 20 27.814 20.0583 26 20.1512V16ZM34.3174 39.6311L34.9894 46.3507C35.0881 47.3373 34.4883 48 33.4969 48H30.5031C29.5117 48 28.9119 47.3373 29.0106 46.3507L29.6826 39.6311C27.3696 38.8521 26 36.8481 26 34C26 30.2977 28.2978 28 32 28C35.7022 28 38 30.2977 38 34C38 36.8481 36.6304 38.8521 34.3174 39.6311Z" />
    </svg>
  );
};
